import { createAsyncThunk } from '@reduxjs/toolkit'
import { find } from 'lodash'

import { socket } from '@/socket'

import { API } from '@/api'
import { LabelingClass, AddClassToGroupPayload } from '@/api/ClassGroup/types'

import { ThunkConfig } from '@/stores/slices/Labeling/types'
import { getLabelingDefaultCondition } from '@/stores/slices/Labeling/utils'

export const addClass = createAsyncThunk<LabelingClass | undefined, AddClassToGroupPayload, ThunkConfig>(
  'labeling/add-class',
  async (payload, thunkAPI) => {
    const id = thunkAPI.getState().labeling.labelingNodeId
    const { user } = thunkAPI.getState().user

    if (!id) {
      throw new Error('Labeling node id not found')
    }

    try {
      const classGroup = await API().ClassGroup.addClassToGroup(payload)
      socket?.Labeling.emitAddClass({
        nodeId: id,
        userId: user._id,
        userName: user.name,
      })
      return find(classGroup.labelingClasses, { name: payload.name })
    } catch (e: any) {
      // axios 에러에서 unique_code 추출
      const uniqueCode = e?.response?.data?.unique_code
      const errorMessage = e?.response?.data?.message || e.message
      return thunkAPI.rejectWithValue({
        uniqueCode,
        message: errorMessage,
      })
    }
  }
)

export const updateClassOrder = createAsyncThunk<LabelingClass[], string[], ThunkConfig>(
  'labeling/update-class-order',
  async (classIds, thunkAPI) => {
    const labelingNodeId = thunkAPI.getState().labeling.labelingNodeId || ''
    const { data: classList } = await API().Labeling.updateUserClassOrder(labelingNodeId, classIds)
    return classList
  },
  { condition: getLabelingDefaultCondition }
)

export const getUserClasses = createAsyncThunk<LabelingClass[], string, ThunkConfig>(
  'labeling/get-user-classes',
  async (labelingNodeId) => {
    const { data: classList } = await API().Labeling.getUserClasses(labelingNodeId)
    return classList
  }
)
